var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWaermepumpeDeactivated = function SvgWaermepumpeDeactivated(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#D4D4D4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 28.377V55.5h47V28.377h-47zM22 51.482c-5.247 0-9.5-4.273-9.5-9.543 0-5.271 4.253-9.543 9.5-9.543 5.246 0 9.5 4.271 9.5 9.543 0 5.27-4.254 9.543-9.5 9.543zM4 32.145v-1.758H.5v7.031H4V35.66h4.5v-3.515zM40.5 51.986h11M40.5 39.93h11M40.5 43.947h11M40.5 47.967h11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 36.664c0-.969-.672-1.758-1.5-1.758-.829 0-1.5.789-1.5 1.758 0 .971 1.5 5.275 1.5 5.275s1.5-4.304 1.5-5.275zM17.47 38.877c-.919-.301-1.872.098-2.128.889-.255.793.283 1.676 1.201 1.977.918.298 5.457.196 5.457.196s-3.612-2.763-4.53-3.062zM17.7 45.32c-.568.787-.485 1.82.184 2.309.671.49 1.675.248 2.243-.537S22 41.939 22 41.939s-3.731 2.596-4.3 3.381zM23.872 47.092c.569.785 1.572 1.027 2.243.539.671-.49.752-1.525.186-2.311-.57-.787-4.301-3.381-4.301-3.381s1.305 4.368 1.872 5.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.457 41.742c.919-.301 1.457-1.184 1.201-1.975-.256-.793-1.209-1.191-2.129-.893-.919.302-4.529 3.065-4.529 3.065s4.537.102 5.457-.197zM36.5 28.377h19V55.5h-19z"
  }))));
};
export default SvgWaermepumpeDeactivated;